import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */ // MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
window.Components.Compound.CheckboxLabel = createReactClass({
  propTypes() {
    return {
      label: PropTypes.string.isRequired,
      labelClasses: PropTypes.string.isRequired,
      onChange: PropTypes.func,
      initChecked: PropTypes.bool,
      disabled: PropTypes.bool
    };
  },
  getDefaultProps() {
    return {
      initChecked: false
    };
  },
  getInitialState() {
    return {
      checked: this.props.initChecked
    };
  },
  checkboxClicked(event) {
    if (this.props.disabled) {
      return;
    }
    this.setState({
      checked: event.target.checked
    });
    if (this.props.onChange) {
      return this.props.onChange(event.target.checked);
    }
  },
  render() {
    const labelStyle = `clickable ${this.props.labelClasses}`;
    return /*#__PURE__*/_jsxs("label", {
      className: labelStyle,
      children: [/*#__PURE__*/_jsx("input", {
        type: "checkbox",
        className: "Checkbox u-mr2x",
        onChange: this.checkboxClicked,
        checked: this.state.checked,
        disabled: this.props.disabled,
        ref: "checkbox"
      }), this.props.label]
    });
  },
  displayName: "CheckboxLabel"
});
window._jsx = _jsx;
window._jsxs = _jsxs;